export const COVERAGE_REPORT_ID = "pNCzq1jXtl3pu9mWiuSd";
export const SAGEMAKER_REPORT_ID = "JS3UcG42Nb3YKsvtsNsJ";
export const RDS_REPORT_ID = "yVf5LquMqryrkf6uQjV7";
